<div>
    <mat-checkbox
        color="primary"
        id="structuremultiselect-{{ field.ID }}"
        [(ngModel)]="structureSettings.multiSelect"
        (change)="saveModel()"
        [disabled]="multiselectLocked || field.ID > 0"
    >
        {{ 'formDetailStructure.allowMultiselect' | t }}
        @if (multiselectLocked) {
            <i
                class="fas fa-info-circle ms-2"
                matTooltip="{{ 'formDetailStructure.controlledByMapback' | t }}"
            ></i>
        }
    </mat-checkbox>
</div>
<div class="row">
    <div class="form-group col">
        <label for="structuresources-{{ field.ID }}">
            {{ 'formDetailStructure.structureSourceLabel' | t }}
            <i
                class="fas fa-info-circle ms-2"
                [matTooltip]="
                    'formDetailStructure.structureSourceTooltip'
                        | t: { state: sourceLocked ? 'locked' : 'unlocked' }
                "
            ></i>
        </label>
        <ng-select
            id="structuresources-{{ field.ID }}"
            name="structuresources-{{ field.ID }}"
            [multiple]="false"
            [items]="sources"
            [(ngModel)]="structureSettings.structureType"
            bindLabel="Value"
            bindValue="Key"
            [disabled]="sourceLocked || field.ID > 0"
            (change)="applyChange()"
        >
        </ng-select>
    </div>
</div>
<div class="row">
    <div class="form-group col">
        <label for="sourcedata-{{ field.ID }}">
            {{ 'formDetailStructure.allowedSourceDataLabel' | t }}
            <i
                class="fas fa-info-circle ms-2"
                [matTooltip]="
                    'formDetailStructure.allowedSourceDataTooltip'
                        | t: { state: parametersLocked ? 'locked' : 'unlocked' }
                "
            ></i>
        </label>
        @if (isTreeSource) {
            <cerrix-select-tree
                [multiselect]="true"
                [tree]="field.SourceData"
                [(value)]="structureSettings.parameters"
                (onChange)="saveModel()"
                [readonly]="parametersLocked"
            >
            </cerrix-select-tree>
        } @else {
            <ng-select
                id="sourcedata-{{ field.ID }}"
                name="sourcedata-{{ field.ID }}"
                [multiple]="true"
                [closeOnSelect]="false"
                [items]="field.SourceData"
                [(ngModel)]="structureSettings.parameters"
                bindLabel="Name"
                bindValue="ID"
                (change)="saveModel()"
                [disabled]="parametersLocked"
            >
            </ng-select>
        }
    </div>
</div>
